export const PSA_CONSTANTS = {
  SCHEDULING_APPOINTMENT_TYPE: { NORMAL: 'NORMAL', PRIVATE: 'PRIVATE' },
  EMAIL_VALIDATION_ERROR_KEYS: {
    // DUPLICATE_EMAIL_ADDRESS: 'app.error.client.duplicateEmailAddress',
    DUPLICATE_EMAIL_ADDRESS: 'app.error.client.user.already.exists',
    INVALID_DOMAIN: 'app.error.client.invalidDomain',
    DUPLICATE_EMAIL_ADDRESS_IN_DIFFERENT_ACCOUNT_TYPE:
      'client.details.user.message.alreadyExist.with.differentAccountType',
    DUPLICATE_EMAIL_ADDRESS_AS_MAILBOX_ADDRESS:
      'app.error.duplicate.email.address.as.mailbox.address'
  },
  MIX_PANEL_EVENTS_FOR_REORDER: {
    PROJECT_DETAILS: {
      TASK: 'Reorder Tasks- Project',
      MILESTONE: 'Reorder Milestones- Project'
    },
    PROJECT_CREATE: {
      TASK: 'Reorder Tasks- Project Creation',
      MILESTONE: 'Reorder Milestones- Project Creation'
    },
    PROJECT_TEMPLATE_CREATE: {
      TASK: 'Reorder Tasks- Project Template Creation',
      MILESTONE: 'Reorder Milestones- Project Template Creation'
    },
    PROJECT_TEMPLATE_EDIT: {
      TASK: 'Reorder Tasks- Project Template',
      MILESTONE: 'Reorder Milestones- Project Template'
    },
    TICKET: 'Reorder Tasks- Ticket',
    RUNBOOK_CREATE: 'Reorder Tasks- Runbook Creation',
    RUNBOOK_EDIT: 'Reorder Tasks- Runbook',
    INVOICE: 'Reorder Line Items- Invoice',
    QUOTE: 'Reorder Line Items- Quotes'
  },
  INCIDENT: 'Incident',
  SERVICE_REQUEST: 'Service Request',
  UPLOAD_MIME_TYPES: [
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'text/csv',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.presentation',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    '.ovpn'
  ].join(','),
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  NEUTRAL: 'NEUTRAL',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON: 'ON',
  GROUP_BY_CATEGORY: {
    CONTRACT: 'CONTRACT',
    WORKLOG: 'WORKLOG',
    SERVICE: 'SERVICE',
    PRODUCT: 'PRODUCT'
  },
  GROUP_BY: {
    SITE: 'SITE',
    SERVICE_CATEGORY: 'SERVICE_CATEGORY'
  },
  INVOICE_TEMPLATE_THEME: {
    CLASSIC: 'CLASSIC',
    MODERN: 'MODERN',
    ELEGANT: 'ELEGANT'
  },
  MAIL_BOX_TYPES: {
    support: 'SUPPORT',
    contact: 'CONTACT',
    invoice: 'INVOICE'
  }
};
